import { SpaceType } from "types/project";

interface SpacesBySpaceTypeInputs {
  fromDate: string;
  toDate: string;
  page?: number;
  perPage?: number;
}

class SpaceService {
  // baseURL: string;

  initRequest: RequestInit;

  constructor() {
    // this.baseURL = `${process.env.REACT_APP_ASSET_API_REST_URI}${process.env.REACT_APP_SPACE_API_BASE_URL}`;
    this.initRequest = {
      method: "GET",
      referrerPolicy: "unsafe-url",
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  // async getSpacesBySpaceType(
  //   projectId: string,
  //   spaceType: SpaceType,
  //   { fromDate, toDate, page = 1, perPage = 100 }: SpacesBySpaceTypeInputs,
  // ) {
  //   const response = await fetch(
  //     `${this.baseURL}/project/${projectId}/${spaceType}?fromDate=${fromDate}&toDate=${toDate}&page=${page}&perPage${perPage}`,
  //     {
  //       ...this.initRequest,
  //     },
  //   );
  //   if (!response.ok) {
  //     throw new Error(`Status: ${response.status}`);
  //   }
  //   const responseContent = await response.json();
  //   return responseContent.data;
  // }

  async getSpaceByID(baseUri: string, spaceID: string) {
    const response = await fetch(`${baseUri}/${spaceID}`, {
      ...this.initRequest,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    const responseContent = await response.json();
    return responseContent.data;
  }
}

export default new SpaceService();
